import script from "./PlaceholderModuleView.vue?vue&type=script&setup=true&lang=js"
export * from "./PlaceholderModuleView.vue?vue&type=script&setup=true&lang=js"

import "./PlaceholderModuleView.vue?vue&type=style&index=0&id=931d1c28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-931d1c28"]])

export default __exports__